<template>
  <div>
    <Modal v-model="isShow" width="900" :mask-closable="false">
      <div class="content" v-if="agreementType === 'VAT'">
        <div class="header">创界通平台服务协议-VAT：</div>
         <UserAgreementVAT></UserAgreementVAT>
      </div>
      <div class="content" v-else>
        <div class="header">创界通平台服务协议-合规认证：</div>
        <UserAgreementEPR></UserAgreementEPR>
      </div>

      <div slot="footer" class="footer">
        <Button type="primary" @click="close(false)">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import UserAgreementVAT from '@/views/common/userAgreement'
import UserAgreementEPR from '@/views/common/userAgreementEPR'
export default {
  props: ['agreementType'],
  data() {
    return {
      isShow: true,
    };
  },
  watch: {
    isShow(val) {
      this.close(val);
    },
  },
  components:{
    UserAgreementVAT,
    UserAgreementEPR
  },
  methods: {
    close(val) {
      this.$emit('changeState', val);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ivu-modal-header {
  display: none;
}
.header {
  font-weight: 700;
  color: #333;
  font-size: 18px;
  margin-bottom: 20px;
}
.footer {
  text-align: center;
  padding-bottom: 40px;
}
.content {
  padding: 0 30px;
  line-height: 26px;
  color: #333;
  h3 {
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
  }
}
/deep/ .ivu-modal-content {
  height: 770px;
  overflow: auto;
}
/deep/ .ivu-modal-close {
  display: none;
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/sureOrder/components/userAgreement29.vue